// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRecoverRouteImport } from './routes/auth/recover'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AdminDealsRouteImport } from './routes/admin/deals'
import { Route as AdminConfigRouteImport } from './routes/admin/config'
import { Route as AdminBrandsRouteImport } from './routes/admin/brands'
import { Route as AdminBillingRouteImport } from './routes/admin/billing'
import { Route as AdminAuditLogsRouteImport } from './routes/admin/audit-logs'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPayorsRouteImport } from './routes/_authenticated/payors'
import { Route as AuthenticatedPaymentsRouteImport } from './routes/_authenticated/payments'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedDealsRouteImport } from './routes/_authenticated/deals'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedComplianceRouteImport } from './routes/_authenticated/compliance'
import { Route as AuthenticatedBrandsRouteImport } from './routes/_authenticated/brands'
import { Route as AuthenticatedAgencyRouteImport } from './routes/_authenticated/agency'
import { Route as AuthenticatedSettingsOrganizationsRouteImport } from './routes/_authenticated/settings/organizations'
import { Route as AuthenticatedCheckoutPlanRouteImport } from './routes/_authenticated/checkout.$plan'
import { Route as AuthenticatedPayorsIndexRouteImport } from './routes/_authenticated/payors/index'
import { Route as AuthenticatedPayorsPayorIdRouteImport } from './routes/_authenticated/payors/$payorId'
import { Route as AuthenticatedDealsIndexRouteImport } from './routes/_authenticated/deals/index'
import { Route as AuthenticatedDealsNewRouteImport } from './routes/_authenticated/deals/new'
import { Route as AuthenticatedDealsImportRouteImport } from './routes/_authenticated/deals/import'
import { Route as AuthenticatedDealsDealIdRouteImport } from './routes/_authenticated/deals/$dealId'
import { Route as AuthenticatedComplianceVerificationsRouteImport } from './routes/_authenticated/compliance/verifications'
import { Route as AuthenticatedBrandsIndexRouteImport } from './routes/_authenticated/brands/index'
import { Route as AuthenticatedBrandsBrandIdRouteImport } from './routes/_authenticated/brands/$brandId'
import { Route as AuthenticatedAgencyRosterRouteImport } from './routes/_authenticated/agency/roster'
import { Route as AuthenticatedComplianceSubmissionsIndexRouteImport } from './routes/_authenticated/compliance/submissions/index'
import { Route as AuthenticatedComplianceSubmissionsSubmissionIdRouteImport } from './routes/_authenticated/compliance/submissions/$submissionId'
import { Route as AuthenticatedAgencyRecruitIndexRouteImport } from './routes/_authenticated/agency/recruit/index'
import { Route as AuthenticatedAgencyRecruitFoundryIdRouteImport } from './routes/_authenticated/agency/recruit/$foundryId'
import { Route as AuthenticatedAgencyAthletesAthleteIdIndexRouteImport } from './routes/_authenticated/agency/athletes/$athleteId/index'
import { Route as AuthenticatedAgencyAthletesAthleteIdDealsNewRouteImport } from './routes/_authenticated/agency/athletes/$athleteId/deals/new'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthRecoverRoute = AuthRecoverRouteImport.update({
            id: '/auth/recover',path: '/auth/recover',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminSupportRoute = AdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AdminRoute
          })
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AdminRoute
          })
const AdminDealsRoute = AdminDealsRouteImport.update({
            id: '/deals',path: '/deals',getParentRoute: () => AdminRoute
          })
const AdminConfigRoute = AdminConfigRouteImport.update({
            id: '/config',path: '/config',getParentRoute: () => AdminRoute
          })
const AdminBrandsRoute = AdminBrandsRouteImport.update({
            id: '/brands',path: '/brands',getParentRoute: () => AdminRoute
          })
const AdminBillingRoute = AdminBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AdminRoute
          })
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => AdminRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPayorsRoute = AuthenticatedPayorsRouteImport.update({
            id: '/payors',path: '/payors',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPaymentsRoute = AuthenticatedPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDealsRoute = AuthenticatedDealsRouteImport.update({
            id: '/deals',path: '/deals',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedComplianceRoute = AuthenticatedComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBrandsRoute = AuthenticatedBrandsRouteImport.update({
            id: '/brands',path: '/brands',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAgencyRoute = AuthenticatedAgencyRouteImport.update({
            id: '/agency',path: '/agency',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsOrganizationsRoute = AuthenticatedSettingsOrganizationsRouteImport.update({
            id: '/settings/organizations',path: '/settings/organizations',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCheckoutPlanRoute = AuthenticatedCheckoutPlanRouteImport.update({
            id: '/checkout/$plan',path: '/checkout/$plan',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPayorsIndexRoute = AuthenticatedPayorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPayorsRoute
          })
const AuthenticatedPayorsPayorIdRoute = AuthenticatedPayorsPayorIdRouteImport.update({
            id: '/$payorId',path: '/$payorId',getParentRoute: () => AuthenticatedPayorsRoute
          })
const AuthenticatedDealsIndexRoute = AuthenticatedDealsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDealsRoute
          })
const AuthenticatedDealsNewRoute = AuthenticatedDealsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedDealsRoute
          })
const AuthenticatedDealsImportRoute = AuthenticatedDealsImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => AuthenticatedDealsRoute
          })
const AuthenticatedDealsDealIdRoute = AuthenticatedDealsDealIdRouteImport.update({
            id: '/$dealId',path: '/$dealId',getParentRoute: () => AuthenticatedDealsRoute
          })
const AuthenticatedComplianceVerificationsRoute = AuthenticatedComplianceVerificationsRouteImport.update({
            id: '/verifications',path: '/verifications',getParentRoute: () => AuthenticatedComplianceRoute
          })
const AuthenticatedBrandsIndexRoute = AuthenticatedBrandsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedBrandsRoute
          })
const AuthenticatedBrandsBrandIdRoute = AuthenticatedBrandsBrandIdRouteImport.update({
            id: '/$brandId',path: '/$brandId',getParentRoute: () => AuthenticatedBrandsRoute
          })
const AuthenticatedAgencyRosterRoute = AuthenticatedAgencyRosterRouteImport.update({
            id: '/roster',path: '/roster',getParentRoute: () => AuthenticatedAgencyRoute
          })
const AuthenticatedComplianceSubmissionsIndexRoute = AuthenticatedComplianceSubmissionsIndexRouteImport.update({
            id: '/submissions/',path: '/submissions/',getParentRoute: () => AuthenticatedComplianceRoute
          })
const AuthenticatedComplianceSubmissionsSubmissionIdRoute = AuthenticatedComplianceSubmissionsSubmissionIdRouteImport.update({
            id: '/submissions/$submissionId',path: '/submissions/$submissionId',getParentRoute: () => AuthenticatedComplianceRoute
          })
const AuthenticatedAgencyRecruitIndexRoute = AuthenticatedAgencyRecruitIndexRouteImport.update({
            id: '/recruit/',path: '/recruit/',getParentRoute: () => AuthenticatedAgencyRoute
          })
const AuthenticatedAgencyRecruitFoundryIdRoute = AuthenticatedAgencyRecruitFoundryIdRouteImport.update({
            id: '/recruit/$foundryId',path: '/recruit/$foundryId',getParentRoute: () => AuthenticatedAgencyRoute
          })
const AuthenticatedAgencyAthletesAthleteIdIndexRoute = AuthenticatedAgencyAthletesAthleteIdIndexRouteImport.update({
            id: '/athletes/$athleteId/',path: '/athletes/$athleteId/',getParentRoute: () => AuthenticatedAgencyRoute
          })
const AuthenticatedAgencyAthletesAthleteIdDealsNewRoute = AuthenticatedAgencyAthletesAthleteIdDealsNewRouteImport.update({
            id: '/athletes/$athleteId/deals/new',path: '/athletes/$athleteId/deals/new',getParentRoute: () => AuthenticatedAgencyRoute
          })





const AuthenticatedAgencyRouteChildren = {
  AuthenticatedAgencyRosterRoute: AuthenticatedAgencyRosterRoute,AuthenticatedAgencyRecruitFoundryIdRoute: AuthenticatedAgencyRecruitFoundryIdRoute,AuthenticatedAgencyRecruitIndexRoute: AuthenticatedAgencyRecruitIndexRoute,AuthenticatedAgencyAthletesAthleteIdIndexRoute: AuthenticatedAgencyAthletesAthleteIdIndexRoute,AuthenticatedAgencyAthletesAthleteIdDealsNewRoute: AuthenticatedAgencyAthletesAthleteIdDealsNewRoute
}

const AuthenticatedAgencyRouteWithChildren = AuthenticatedAgencyRoute._addFileChildren(AuthenticatedAgencyRouteChildren)




const AuthenticatedBrandsRouteChildren = {
  AuthenticatedBrandsBrandIdRoute: AuthenticatedBrandsBrandIdRoute,AuthenticatedBrandsIndexRoute: AuthenticatedBrandsIndexRoute
}

const AuthenticatedBrandsRouteWithChildren = AuthenticatedBrandsRoute._addFileChildren(AuthenticatedBrandsRouteChildren)




const AuthenticatedComplianceRouteChildren = {
  AuthenticatedComplianceVerificationsRoute: AuthenticatedComplianceVerificationsRoute,AuthenticatedComplianceSubmissionsSubmissionIdRoute: AuthenticatedComplianceSubmissionsSubmissionIdRoute,AuthenticatedComplianceSubmissionsIndexRoute: AuthenticatedComplianceSubmissionsIndexRoute
}

const AuthenticatedComplianceRouteWithChildren = AuthenticatedComplianceRoute._addFileChildren(AuthenticatedComplianceRouteChildren)




const AuthenticatedDealsRouteChildren = {
  AuthenticatedDealsDealIdRoute: AuthenticatedDealsDealIdRoute,AuthenticatedDealsImportRoute: AuthenticatedDealsImportRoute,AuthenticatedDealsNewRoute: AuthenticatedDealsNewRoute,AuthenticatedDealsIndexRoute: AuthenticatedDealsIndexRoute
}

const AuthenticatedDealsRouteWithChildren = AuthenticatedDealsRoute._addFileChildren(AuthenticatedDealsRouteChildren)




const AuthenticatedPayorsRouteChildren = {
  AuthenticatedPayorsPayorIdRoute: AuthenticatedPayorsPayorIdRoute,AuthenticatedPayorsIndexRoute: AuthenticatedPayorsIndexRoute
}

const AuthenticatedPayorsRouteWithChildren = AuthenticatedPayorsRoute._addFileChildren(AuthenticatedPayorsRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAgencyRoute: AuthenticatedAgencyRouteWithChildren,AuthenticatedBrandsRoute: AuthenticatedBrandsRouteWithChildren,AuthenticatedComplianceRoute: AuthenticatedComplianceRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDealsRoute: AuthenticatedDealsRouteWithChildren,AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,AuthenticatedPaymentsRoute: AuthenticatedPaymentsRoute,AuthenticatedPayorsRoute: AuthenticatedPayorsRouteWithChildren,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedCheckoutPlanRoute: AuthenticatedCheckoutPlanRoute,AuthenticatedSettingsOrganizationsRoute: AuthenticatedSettingsOrganizationsRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const AdminRouteChildren = {
  AdminAuditLogsRoute: AdminAuditLogsRoute,AdminBillingRoute: AdminBillingRoute,AdminBrandsRoute: AdminBrandsRoute,AdminConfigRoute: AdminConfigRoute,AdminDealsRoute: AdminDealsRoute,AdminOrganizationsRoute: AdminOrganizationsRoute,AdminSupportRoute: AdminSupportRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AdminRoute: AdminRouteWithChildren,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,AuthLoginRoute: AuthLoginRoute,AuthRecoverRoute: AuthRecoverRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)